import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WorkerTagOption, toggleWorkerTag } from '../worker-tags.util';

@Component({
  selector: 'app-worker-tag-picker',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './worker-tag-picker.html',
  styleUrl: './worker-tag-picker.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkerTagPickerComponent {
  readonly options = input<readonly WorkerTagOption[]>([]);
  readonly model = input<readonly string[]>([]);
  readonly disabled = input(false);
  readonly modelChange = output<string[]>();

  readonly chips = computed(() => {
    const selected = new Set(this.model());
    return this.options().map(option => ({
      label: option.label,
      value: option.value,
      selected: selected.has(option.value),
    }));
  });

  toggle(value: string): void {
    if (this.disabled()) {
      return;
    }
    this.modelChange.emit(toggleWorkerTag(this.model(), value));
  }
}
